export enum PaymentChaseType {
  FULL_PAYMENT = 'FULL_PAYMENT',
  PERCENTAGE_DEPOSIT = 'PERCENTAGE_DEPOSIT',
  FLAT_FEE_DEPOSIT = 'FLAT_FEE_DEPOSIT'
}
